(() => {
  if (customElements.get('dio-warranty-form')) return;
  const countryCodes = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (window.dioWarrantyTurnstile) return window.dioWarrantyTurnstile;
    window.dioWarrantyTurnstile = new Promise((resolve, reject) => {
      window.dioWarrantyTurnstileReady = () => resolve(window.turnstile);
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=dioWarrantyTurnstileReady&render=explicit';
      script.async = true;
      script.onerror = reject;
      document.head.append(script);
    });
    return window.dioWarrantyTurnstile;
  }
  class DioWarrantyForm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[data-submit]');
      this.submitLabel = this.submitButton.textContent;
      this.status = this.querySelector('[data-status]');
      this.country = this.form.elements.country;
      this.speakers = this.querySelector('[data-speakers]');
      this.addButton = this.querySelector('[data-add]');
      this.token = '';
      this.busy = false;
      this.sequence = 1;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const names = new Intl.DisplayNames(['en'], {type: 'region'});
      countryCodes.filter(code => code !== 'US' && code !== 'CA')
        .map(code => ({code, name: names.of(code)}))
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach(country => this.country.add(new Option(country.name, country.code)));
      this.country.addEventListener('change', () => {
        this.querySelector('[data-consent]').hidden = this.country.value === 'US';
        this.form.elements.marketingConsent.checked = false;
      }, options);
      this.addButton.addEventListener('click', () => this.addSpeaker(), options);
      this.form.addEventListener('submit', event => this.save(event), options);
      this.form.addEventListener('input', () => this.updateButton(), options);
      window.addEventListener('message', event => this.receive(event), options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.restoreForm();
      }, options);
      this.querySelector('[data-continue]').hidden = !this.dataset.destination;
      this.updateButton();
      this.verificationTimer = setTimeout(() => {
        if (!this.token && this.hasSerials()) this.message(this.labels.verification, true);
      }, 30000);
      loadTurnstile().then(api => {
        if (!this.isConnected) return;
        this.widget = api.render(this.querySelector('[data-verification]'), {
          sitekey: this.dataset.siteKey, action: 'warranty-registration',
          callback: token => {this.token = token; clearTimeout(this.verificationTimer); if (!this.busy) this.message('', false); this.updateButton();},
          'expired-callback': () => {this.token = ''; this.updateButton();},
          'error-callback': () => {this.token = ''; if (this.hasSerials()) this.message(this.labels.verification, true); this.updateButton();}
        });
      }).catch(() => {if (this.hasSerials()) this.message(this.labels.verification, true);});
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.verificationTimer);
      this.clearAttempt();
      if (this.widget !== undefined && window.turnstile) window.turnstile.remove(this.widget);
      this.ready = false;
    }
    randomId() {
      return Array.from(crypto.getRandomValues(new Uint8Array(24)), value => value.toString(16).padStart(2, '0')).join('');
    }
    message(text, error) {
      this.status.textContent = text;
      this.status.dataset.error = String(error);
    }
    hasSerials() {return Array.from(this.querySelectorAll('[data-serial]')).some(input => input.value.trim());}
    updateButton() {
      const registering = this.hasSerials();
      this.form.elements.email.required = registering;
      if (!registering && !this.busy) this.message('', false);
      this.submitButton.disabled = this.busy || (registering && !this.token);
    }
    addSpeaker() {
      if (this.speakers.children.length >= 20) return;
      const row = this.speakers.firstElementChild.cloneNode(true);
      row.querySelector('[data-serial]').value = '';
      row.querySelector('[data-serial]').id = `${this.speakers.firstElementChild.querySelector('input').id}-${++this.sequence}`;
      row.querySelector('label').htmlFor = row.querySelector('input').id;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'dio-warranty__remove';
      remove.textContent = this.labels.remove;
      remove.addEventListener('click', () => {row.remove(); this.renumber();});
      row.append(remove); this.speakers.append(row); this.renumber();
      row.querySelector('input').focus();
    }
    renumber() {
      Array.from(this.speakers.children).forEach((row, index) => {
        row.querySelector('label').textContent = `${this.labels.serial} ${index + 1}`;
      });
      this.addButton.hidden = this.speakers.children.length >= 20;
      this.updateButton();
    }
    save(event) {
      event.preventDefault();
      if (this.busy) return;
      this.updateButton();
      if (!this.hasSerials()) {
        if (this.dataset.destination) this.navigate(this.dataset.destination);
        return;
      }
      if (!this.token || !this.form.reportValidity()) return;
      const speakers = Array.from(this.querySelectorAll('[data-serial]')).filter(input => input.value.trim()).map(input => {
        input.value = input.value.trim().toUpperCase();
        return {serialNumber: input.value, product: 'Dio Node'};
      });
      if (new Set(speakers.map(speaker => speaker.serialNumber)).size !== speakers.length) {
        this.message(this.labels.duplicate, true); return;
      }
      const data = {email: this.form.elements.email.value.trim().toLowerCase(), country: this.country.value,
        speakers, marketingConsent: this.country.value !== 'US' && this.form.elements.marketingConsent.checked,
        termsVersion: '2026-10-04', source: 'Shopify website', website: this.form.elements.website.value};
      const signature = JSON.stringify(data);
      if (signature !== this.lastSignature) {this.submissionId = this.randomId(); this.lastSignature = signature;}
      this.clearAttempt();
      this.nonce = this.randomId();
      const endpoint = new URL(this.dataset.endpoint);
      if (endpoint.origin !== 'https://script.google.com' || !endpoint.pathname.endsWith('/exec')) {
        this.message(this.labels.unavailable, true); return;
      }
      const frame = document.createElement('iframe');
      frame.name = `dio-warranty-${this.nonce}`; frame.hidden = true; frame.title = 'Warranty registration response';
      const transport = document.createElement('form');
      transport.hidden = true; transport.method = 'post'; transport.action = endpoint.href; transport.target = frame.name;
      const payload = document.createElement('input');
      payload.type = 'hidden'; payload.name = 'payload';
      payload.value = JSON.stringify({...data, submissionId: this.submissionId, turnstileToken: this.token,
        transport: 'iframe', responseOrigin: window.location.origin, responseNonce: this.nonce});
      transport.append(payload); this.frame = frame; this.transport = transport;
      this.append(frame, transport);
      this.busy = true; this.form.querySelector('fieldset').disabled = true;
      this.submitButton.textContent = this.labels.saving; this.message('', false); this.updateButton();
      this.timer = setTimeout(() => this.failed(this.labels.timeout), 60000);
      HTMLFormElement.prototype.submit.call(transport);
    }
    receive(event) {
      let origin;
      try {origin = new URL(event.origin);} catch {return;}
      if (origin.protocol !== 'https:' || !(origin.hostname === 'script.google.com' ||
          origin.hostname === 'script.googleusercontent.com' || origin.hostname.endsWith('-script.googleusercontent.com'))) return;
      const result = event.data;
      if (!this.busy || !result || result.type !== 'dio-warranty-result' || result.nonce !== this.nonce) return;
      if (result.success === true && typeof result.submissionId === 'string') {
        this.clearAttempt();
        if (this.dataset.redirect === 'true' && this.dataset.destination) {
          this.navigate(this.dataset.destination);
          return;
        }
        this.busy = false; this.form.hidden = true;
        this.querySelector('[data-success]').hidden = false;
      } else {this.failed(typeof result.message === 'string' ? result.message : this.labels.unavailable);}
    }
    navigate(destination) {window.location.assign(destination);}
    restoreForm() {
      this.busy = false; this.clearAttempt(); this.form.hidden = false;
      this.querySelector('[data-success]').hidden = true;
      this.form.querySelector('fieldset').disabled = false;
      this.submitButton.textContent = this.submitLabel;
      this.token = ''; this.message('', false);
      if (this.widget !== undefined && window.turnstile) window.turnstile.reset(this.widget);
      this.updateButton();
    }
    failed(message) {
      this.busy = false; this.clearAttempt(); this.form.querySelector('fieldset').disabled = false;
      this.submitButton.textContent = this.submitLabel; this.token = ''; this.message(message, true);
      if (this.widget !== undefined) window.turnstile.reset(this.widget);
      this.updateButton();
    }
    clearAttempt() {
      clearTimeout(this.timer); this.frame?.remove(); this.transport?.remove(); this.nonce = '';
    }
  }
  customElements.define('dio-warranty-form', DioWarrantyForm);
})();
